import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const okrugsRoutes: Route[] = [
    {
        path: 'okrugs',
        title: 'PRSS | Округа Москвы',
        loadComponent: () =>
            import('@pages/guids/okrugs/okrugs.component').then((c) => c.OkrugsComponent),
        canActivate: [authGuard, guard('watch_refs_okrugs')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Округа Москвы', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
];
